import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {JobInstruments} from '../models/instrument/jobInstruments.model';

@Injectable({
  providedIn: 'root'
})
export class InstrumentService {

  constructor(private http: HttpClient) {
  }

  private JOB_URL: string = environment.BASE_URL + 'job';

  /**
   * GETS
   */
  public getJobInstruments(id: string): Observable<JobInstruments> {
    return this.http.get<JobInstruments>(`${this.JOB_URL}/${id}/instruments`).pipe();
  }

  /**
   * CREATES
   */


  /**
   * UPDATES
   */
  public updateJobInstruments(jobInstruments: JobInstruments): Observable<JobInstruments> {
    return this.http.patch<JobInstruments>(`${this.JOB_URL}/${jobInstruments.id}/instruments`, jobInstruments).pipe();
  }

  /**
   * DELETE
   */


}
